import { Check, ChevronDown, Globe2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { AVAILABLE_LANGS } from "@/i18n";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const current =
    AVAILABLE_LANGS.find((l) => l.code === i18n.resolvedLanguage) ||
    AVAILABLE_LANGS[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        {/* Bigger, more reachable target: flag + code + caret so the whole
            strip is clickable (no longer a 16px icon that's easy to miss). */}
        <Button
          variant="outline"
          size="sm"
          className="h-9 gap-1.5 px-2.5 font-medium"
          data-testid="language-switcher"
          aria-label={t("common.language", "Language")}
          title={current.label}
        >
          <Globe2 className="h-4 w-4 opacity-70" />
          <span className="text-base leading-none">{current.flag}</span>
          <span className="text-xs uppercase tracking-wider">{current.code}</span>
          <ChevronDown className="h-3.5 w-3.5 opacity-60" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48" sideOffset={6}>
        <DropdownMenuLabel className="text-[11px] uppercase tracking-wider text-muted-foreground">
          {t("common.language", "Language")}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {AVAILABLE_LANGS.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => i18n.changeLanguage(l.code)}
            data-testid={`lang-${l.code}`}
            className="cursor-pointer flex items-center gap-2"
          >
            <span className="text-base leading-none">{l.flag}</span>
            <span className="flex-1">{l.label}</span>
            {current.code === l.code && (
              <Check className="h-3.5 w-3.5 text-[hsl(var(--ok))]" />
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
